module.exports = __webpack_public_path__ + "static/media/logo.5bead85d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/logo.svg
// module id = 151
// module chunks = 0